import { render, staticRenderFns } from "./NewsYbh.vue?vue&type=template&id=52983f66"
import script from "./NewsYbh.vue?vue&type=script&lang=ts"
export * from "./NewsYbh.vue?vue&type=script&lang=ts"
import style0 from "./NewsYbh.vue?vue&type=style&index=0&id=52983f66&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports